import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["backToTop"]

  connect() {
    this.handleScroll = this.handleScroll.bind(this)
    window.addEventListener('scroll', this.handleScroll)
    this.handleScroll() // Check initial state
  }

  disconnect() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll() {
    const scrolled = window.pageYOffset

    // Show/hide back to top button
    if (this.hasBackToTopTarget) {
      if (scrolled > 500) {
        this.backToTopTarget.classList.add('visible')
      } else {
        this.backToTopTarget.classList.remove('visible')
      }
    }
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }
}
